var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c(
        "custom-callout",
        { attrs: { "border-color": "#b5c3bc", "has-toggle": false } },
        [
          _c("div", { staticClass: "row pt-2" }, [
            _c("div", { staticClass: "col-12 col-md-2 custom-pl" }, [
              _c("div", { staticClass: "d-flex flex-column" }, [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v("Proveedor")
                ]),
                _c(
                  "span",
                  { staticClass: "font-16 color-black font-weight-bold" },
                  [_vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.name)) + " ")]
                )
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-2 custom-pl" }, [
              _c("div", { staticClass: "d-flex flex-column" }, [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v(" Representante del Proveedor ")
                ]),
                _c(
                  "span",
                  { staticClass: "font-16 color-black font-weight-bold" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm._f("empty")(_vm.data.representant)) + " "
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-2 custom-pl" }, [
              _c("div", { staticClass: "d-flex flex-column" }, [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v("Teléfono")
                ]),
                _c(
                  "span",
                  { staticClass: "font-16 color-black font-weight-bold" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm._f("phone")(_vm.data.phoneNumber)) + " "
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-2 custom-pl" }, [
              _c("div", { staticClass: "d-flex flex-column" }, [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v("Correo Electrónico")
                ]),
                _c(
                  "span",
                  {
                    staticClass:
                      "font-16 color-black font-weight-bold text-truncate"
                  },
                  [_vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.email)) + " ")]
                )
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-2 custom-pl" }, [
              _c("div", { staticClass: "d-flex flex-column" }, [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v("Dirección")
                ]),
                _c(
                  "span",
                  { staticClass: "font-16 color-black font-weight-bold" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm._f("empty")(_vm.data.address)) + " "
                    )
                  ]
                )
              ])
            ]),
            !_vm.isReadOnly
              ? _c("div", { staticClass: "col-12 col-md-2 custom-pl" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-md-end h-100"
                    },
                    [
                      _c("check-box", {
                        staticClass: "row-check",
                        attrs: { value: _vm.data.checked },
                        on: { input: _vm.onToggle }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }